import { cx } from '../../lib/cx';
import type { BadgeProps, BadgeTone } from './types';

const TONES: Record<BadgeTone, string> = {
  gray: 'bg-gray-100 text-gray-700',
  brand: 'bg-brand-100 text-brand-700',
  success: 'bg-success-100 text-success-700',
  warning: 'bg-warning-100 text-warning-700',
  danger: 'bg-danger-100 text-danger-700',
  info: 'bg-info-100 text-info-700',
  accent: 'bg-accent-100 text-accent-700',
};

/**
 * A pill for statuses and counts. A signal, never a button.
 */
export const Badge = ({ tone = 'gray', children, className }: BadgeProps) => (
  <span
    className={cx(
      'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
      TONES[tone],
      className,
    )}
  >
    {children}
  </span>
);
